module.exports = __webpack_public_path__ + "static/media/medio_camion.2ba396d7.svg";